mutation DisableMfa {
  disableMfa(input: {}) {
    success
    errors
  }
}
